<template>
  <v-dialog :value="showDialog" max-width="400" persistent>
    <v-card class="card-pad text-center">
      <strong>{{ title }}</strong>

      <br />

      <div class="caption--text text-body-2 mb-4">
        {{ message }}
      </div>

      <v-btn
        depressed
        :disabled="loading"
        @click="$emit('close')"
        class="ma-1 secondary-button"
      >
        {{ cancelLabel }}
      </v-btn>

      <v-btn
        depressed
        :loading="loading"
        class="ma-1 quaternary-button"
        color="#FF4F64"
        @click="$emit('confirm')"
      >
        {{ confirmLabel }}
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteConfirmDialog',
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cancelLabel: {
      type: String,
      default: 'Cancelar',
    },
    confirmLabel: {
      type: String,
      default: 'Remover',
    },
  },
}
</script>
